/* The Sunday Sleep Guide (sections/sunday-sleep-guide.liquid): the chapter bar shows the current chapter,
   contents open beside the text from 960 px and mark the question being read, a source number opens the
   sources and highlights its line, copy link, print, and the phone dock waits until the first screen is passed. */
const root = document.querySelector('[data-sg]');
if (root) {
  const wide = () => matchMedia('(min-width: 960px)').matches;
  const scroller = () => {
    const pw = document.querySelector('.page-wrapper');
    return pw && pw.scrollHeight > pw.clientHeight + 4 && getComputedStyle(pw).overflowY !== 'visible' ? pw : window;
  };
  const top = () => { const s = scroller(); return s === window ? window.scrollY : s.scrollTop; };

  /* chapter bar: current chapter in view */
  const bar = root.querySelector('.sg-bar'), cur = bar && bar.querySelector('[aria-current]');
  const centre = () => { if (!cur || bar.scrollWidth <= bar.clientWidth + 2) return; const a = cur.getBoundingClientRect(), b = bar.getBoundingClientRect(); bar.scrollLeft += a.left - b.left - (b.width - a.width) / 2; };
  centre(); requestAnimationFrame(centre);

  /* contents */
  const toc = root.querySelector('[data-sg-toc]');
  if (toc && wide()) toc.open = true;
  const links = toc ? [...toc.querySelectorAll('a')] : [];
  const heads = links.map(a => document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
  if (heads.length && 'IntersectionObserver' in window) {
    const seen = new Map();
    const io = new IntersectionObserver(es => {
      es.forEach(e => seen.set(e.target.id, e.boundingClientRect.top));
      let id = null; for (const h of heads) { if (h.getBoundingClientRect().top < 140) id = h.id; }
      links.forEach(a => a.toggleAttribute('aria-current', a.getAttribute('href') === '#' + id));
    }, { rootMargin: '0px 0px -60% 0px', threshold: [0, 1] });
    heads.forEach(h => io.observe(h));
  }
  root.addEventListener('click', e => {
    const a = e.target.closest('.sg-toc a');
    if (a && toc && !wide()) toc.open = false;
  });

  /* sources: open, scroll, highlight */
  const src = document.getElementById('sg-sources');
  const openSrc = id => {
    if (!src) return; src.open = true;
    const li = id ? document.getElementById(id) : src;
    if (!li) return;
    li.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    if (id) { li.classList.add('sg-hl'); setTimeout(() => li.classList.remove('sg-hl'), 1600); }
  };
  root.addEventListener('click', e => {
    const c = e.target.closest('a.sg-cite, [data-sg-src]');
    if (!c) return;
    e.preventDefault();
    const h = c.getAttribute('href') || '';
    openSrc(c.matches('.sg-cite') ? h.slice(1) : null);
  });
  if (/^#sgs\d+$/.test(location.hash)) openSrc(location.hash.slice(1));
  if (/^#sgf\d+$/.test(location.hash)) { const d = document.getElementById(location.hash.slice(1)); if (d) d.open = true; }

  /* share */
  root.querySelector('[data-sg-copy]')?.addEventListener('click', async e => {
    const b = e.currentTarget, sp = b.querySelector('span');
    try { await navigator.clipboard.writeText(location.origin + location.pathname); } catch (x) {}
    if (sp) sp.textContent = b.dataset.done;
  });
  const openAll = () => root.querySelectorAll('details').forEach(d => { d.open = true; });
  root.querySelector('[data-sg-print]')?.addEventListener('click', () => { openAll(); window.print(); });
  addEventListener('beforeprint', openAll);

  /* phone dock: Menu · Contents · Next chapter, after the first screen */
  const dock = document.getElementById('dock');
  if (dock && dock.hasAttribute('data-sg-dock')) {
    const tick = () => dock.classList.toggle('sg-dkoff', top() < Math.min(560, innerHeight * 0.7));
    tick();
    window.addEventListener('scroll', tick, { passive: true });
    document.querySelector('.page-wrapper')?.addEventListener('scroll', tick, { passive: true });
    dock.querySelector('[data-sg-contents]')?.addEventListener('click', () => {
      if (!toc) return; toc.open = true;
      document.getElementById('sg-toc-top')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}
